class SecureRequestFetch {
  constructor() {
    this.baseURL = process.env.BASE_URL;
  }

  async get(url, additionalHeaders = {}) {
    const headers = await this.createHeaders(additionalHeaders);
    const response = await fetch(`${this.baseURL}${url}`, {
      method: "GET",
      headers,
      // The `.foo.com` session cookie authenticates the request — no token
      // handling on the frontend.
      credentials: "include",
    });
    return this.processResponse(response);
  }

  async createHeaders(additionalHeaders) {
    return {
      "Content-Type": "application/json",
      ...additionalHeaders,
    };
  }

  async processResponse(response) {
    if (!response.ok) {
      throw new Error(`Network response was not ok: ${response.statusText}`);
    }

    const contentType = response.headers.get("Content-Type");
    let data = "";
    if (contentType.includes("application/json")) {
      data = await response.json();
      return {
        data: data,
        headers: response.headers,
      };
    } else if (contentType.includes("application/pdf") || contentType.includes("blob")) {
      data = await response.blob();
      return {
        data: data,
        headers: response.headers,
      };
    } else {
      throw new Error("Unsupported content type: " + contentType);
    }
  }
}

export default SecureRequestFetch;
